// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1_VUw","box":"WorkspacesBox_box__2M4dp","node":"WorkspacesBox_node__2PqRg"};